// @ts-nocheck
/* eslint-disable */
import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { AuthContext } from '@oneaudi/myaudi-kit-utils';
import { PartnerContext } from '../../../contexts/partner-context';
import { useTrackingManager } from '../../../hooks/useTrackingManager';
import type { CtaButtonProps } from './CtaBar';
import { getCtaLabel } from '../../../utils/getCTALabel';

export type ClickHandler = (event: React.MouseEvent<HTMLElement>, partnerId: string) => unknown;

export type CtaCallbackButtonProps = CtaButtonProps & {
  clickHandler: ClickHandler;
  setShowModal?: (show: boolean) => void;
  isSetPartner: boolean;
};

export const CtaCallbackButton = ({
  variant,
  label,
  displayname,
  position,
  setShowModal,
  clickHandler,
  isSetPartner,
}: CtaCallbackButtonProps): React.ReactElement => {
  const { partner } = React.useContext(PartnerContext);
  const authService = React.useContext(AuthContext);

  const trackingManager = useTrackingManager();
  return (
    <CustomButton
      variant={variant}
      onClick={(event) => {
        if (variant === 'primary' && isSetPartner && authService) {
          setShowModal(true);
        } else {
          clickHandler(event, partner.partnerId);
        }
        trackingManager.click('exit_link', '', 'cta', label, displayname, position, label);
      }}
    >
      {getCtaLabel(label)}
    </CustomButton>
  );
};

const CustomButton = styled(TextButton)`
  width: 100%;
`;
